import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/images/doc.png'


const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, " Claim Documents ", -1)
const _hoisted_3 = { class: "documents-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "documents-items"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "doc image",
  width: "95",
  height: "55"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DragDrop = _resolveComponent("DragDrop")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.claim?.Documents?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim?.Documents, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "documents-item",
                  key: index
                }, [
                  _createElementVNode("h5", null, [
                    _createElementVNode("a", {
                      href: "javascript;",
                      onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: doc?.DocumentID, FilePreview: doc?.FilePreview, Type: 'claims' })), ["prevent"])
                    }, _toDisplayString(doc?.Description || doc?.FileName), 9, _hoisted_5)
                  ]),
                  _hoisted_6
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DragDrop, {
          reset: _ctx.reset,
          onUpdateFiles: _ctx.handleUpload,
          onDelete: _ctx.handleDelete,
          accept: ".pdf, .jpg, .jpeg, .png, .tif, .tiff, .bmp, .gif, .wmf, .emf, .psd, .wbmp, .tla, .pcx, .tga"
        }, null, 8, ["reset", "onUpdateFiles", "onDelete"])
      ])
    ]),
    _createVNode(_component_Textarea, {
      label: "Comments/Notes",
      modelValue: _ctx.claim.Notes,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.claim.Notes) = $event)),
      max: 500
    }, null, 8, ["modelValue"])
  ], 64))
}